export default function isReactNative() {
	return (
		typeof window !== 'undefined' &&
		window.navigator &&
		window.navigator.product &&
		window.navigator.product === 'ReactNative'
	)
}
